module.exports = __webpack_public_path__ + "media/images/pic/testimonials/wiktoria-61343e4c5b6556e499356c11c3b63f70.webp";